import { FC } from "react";
import "./ContactCard.scss";

interface IContactCardProps {
  name: string;
  title: string;
  phone: string;
  email: string;
  fax?: string;
}

export const ContactCard: FC<IContactCardProps> = ({
  name,
  title,
  phone,
  email,
  fax,
}) => {
  return (
    <div className="ContactCard">
      <p className="ContactCard__name">{name}</p>
      <p>{title}</p>
      <p>{phone}</p>
      {fax ? <p>{fax}</p> : ""}
      <p className="ContactCard__email">
        <a href={`mailto:${email}`}>{email}</a>
      </p>
    </div>
  );
};
